import { Seo } from "@/components/site/primitives";
import { OButton } from "@/components/site/OButton";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] pt-40 pb-32 oraya-container flex flex-col items-center justify-center text-center" data-testid="notfound-page">
      <Seo title="Not found — ORAYA" description="Page not found." />
      <span className="display text-8xl font-light text-subtle/30">404</span>
      <h1 className="display text-3xl font-light text-ink mt-6">This page doesn't exist.</h1>
      <p className="text-subtle mt-3">The system you're looking for isn't here.</p>
      <div className="mt-8"><OButton to="/" variant="primary">Return home</OButton></div>
    </div>
  );
}
